// extracted by mini-css-extract-plugin
export default {"canvas":"styles_canvas__1lXCA","mobileViewClass":"styles_mobileViewClass__eJgp7"};